import React, { useRef, useState, useContext } from "react";
import Space from "antd/es/space";
import Input from "antd/es/input";
import Alert from "antd/es/alert";

import { UserOutlined, LockOutlined, ShopOutlined } from "@ant-design/icons";
import { registUser } from "@/server/userManager";
import { TipsContext } from "@/context/Tips";

import "./index.less";

export default function UserAccount() {
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("账号或不能为空");
  const { useMessage } = useContext(TipsContext);

  const account = useRef("");
  const password = useRef("");
  const shopId = useRef("");
  return (
    <div className="user-account-wrap items-center justify-center">
      <Space direction="vertical" size={28}>
        <Input
          style={{ borderRadius: 2 }}
          placeholder="请输入账号"
          prefix={<UserOutlined style={{ color: "#1890FF" }} />}
          onChange={(e) => {
            account.current = e.target.value;
          }}
        />
        <Input
          style={{ borderRadius: 2 }}
          placeholder="店铺ID"
          prefix={<ShopOutlined style={{ color: "#1890FF" }} />}
          onChange={(e) => {
            shopId.current = e.target.value;
          }}
        />
        <Input.Password
          style={{ borderRadius: 2 }}
          placeholder="请输入密码"
          prefix={<LockOutlined style={{ color: "#1890FF" }} />}
          onChange={(e) => {
            password.current = e.target.value;
          }}
        />
        <Space direction="vertical" size={22}>
          {showError && (
            <Alert
              message={errorMsg}
              type="error"
              showIcon={true}
              style={{
                color: "#ff2e2e",
              }}
            />
          )}
          <div
            className="submit"
            onClick={() => {
              // TODO 需要增加检测用户名是否存在
              if (
                account.current === "" ||
                password.current === "" ||
                shopId.current === ""
              ) {
                useMessage.error("账号、密码和店铺ID不能为空");
              } else {
                registUser({
                  user_name: account.current,
                  password: password.current,
                  shop_id: shopId.current,
                }).then(
                  (res) => {
                    useMessage.success("添加成功");
                  },
                  (err) => {
                    useMessage.error("用户名已注册");
                  }
                );
              }
            }}
          >
            添加
          </div>
        </Space>
      </Space>
    </div>
  );
}
